// Keelis Assets
// import logo from "../assest/LogoAndFavicon/keelislogo.png";
// import favicon from "../assest/LogoAndFavicon/favicon/keelisfavicon.png";

// //Eg Assests
import logo from "../assest/LogoAndFavicon/EGLogo.png";
import favicon from "../assest/LogoAndFavicon/favicon/EGFavIcon.png";

// *********************Keelis Assets*******************************************************

// Development;
// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Keelis",
//   actualname: "Keel Info Solution Private Limited",
//   baseurl: "https://keelishrmsbk.keelisdev.in/graphql/",
//   mediaurl: "https://keelishrmsbk.keelisdev.in/media",
//   pdfurl: "https://keelishrmsbk.keelisdev.in/media/",
//   loginname: "Keelis",
//   SECRET_KEY: "EGIDEV2026",
// };

// Testing;
// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Keelis",
//   actualname: "Keel Info Solution Private Limited",
//   baseurl: "https://hrmstestbk.keelistest.in/graphql/",
//   mediaurl: "https://hrmstestbk.keelistest.in/media",
//   pdfurl: "https://hrmstestbk.keelistest.in/media/",
//   loginname: "Keelis",
//   SECRET_KEY: "1234",
// };

//live

// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Keelis",
//   actualname: "Keel Info Solution Private Limited",
//   baseurl: "https://hrmsdbdemobk.keelis.in/graphql/",
//   mediaurl: "https://hrmsdbdemobk.keelis.in/media",
//   pdfurl: "https://hrmsdbdemobk.keelis.in/media/",
//   loginname: "Keelis",
//   SECRET_KEY: "EGIPROD2026",
// };

// *****************************EG Assets**********************************************

//Development
const assets = {
  logo: logo,
  favicon: favicon,
  company: "Eg",
  actualname: "EverGuard Insurance Broking Services Private Limited",
  baseurl: " https://eghrmsbk.keelisdev.in/graphql/",
  mediaurl: " https://eghrmsbk.keelisdev.in/media",
  pdfurl: " https://eghrmsbk.keelisdev.in/media/",
  loginCookieBackend: "eghrmsbk.keelisdev.in",
  loginname: "EverGuard",
  logouturl: "https://egtech.keelisdev.in/",
  SECRET_KEY: "EGIDEV2026",
};

//test
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Eg',
//   actualname:"EverGuard Insurance Broking Services Private Limited",
//   baseurl:" https://eghrmsbk.keelistest.in/graphql/",
//   mediaurl:" https://eghrmsbk.keelistest.in/media",
//   pdfurl:' https://eghrmsbk.keelistest.in/media/',
//   loginname:'EverGuard',
//   SECRET_KEY: "1234",
// };

// //test new
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Eg',
//   actualname:"EverGaurd Insurance Broking Services Private Limited",
//   baseurl:"http://www.eghrmsnewbk.keelistest.in/graphql/",
//   mediaurl:"http://www.eghrmsnewbk.keelistest.in/media",
//   pdfurl:'http://www.eghrmsnewbk.keelistest.in/media/',
//   loginname:'EverGuard',
//   SECRET_KEY: "1234",
// };

//Live

// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Eg",
//   actualname: "EverGuard Insurance Broking Services Private Limited",
//   baseurl: "https://hrmsbk.egtech.in/graphql/",
//   mediaurl: "https://hrmsbk.egtech.in/media",
//   pdfurl: "https://hrmsbk.egtech.in/media/",
//   loginname: "EverGuard",
//   logouturl: "https://egtech.in/",
//   SECRET_KEY: "EGIPROD2026",
// };

export default assets;
